// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar-Id7l8o"};